<div class="d-flex flex-column">
    <div class="progress-item" *ngFor="let progresItem of progresItems">
        <ng-container *ngIf="step! > progresItem.index; else defaultStructure">
            <a
                class="d-flex align-items-center progress-item-cont"
                [href]="progresItem.url"
            >
                <span
                    class="index-item d-flex justify-content-center align-items-center"
                    [ngClass]="{ covered: step! > progresItem.index }"
                >
                    {{ progresItem.index }}
                </span>
                <p class="text-uppercase">{{ progresItem.name | translate }}</p>
            </a>
        </ng-container>
        <ng-template #defaultStructure>
            <div
                class="d-flex align-items-center progress-item-cont"
                [ngClass]="{ active: step! === progresItem.index }"
            >
                <span
                    class="index-item d-flex justify-content-center align-items-center"
                    [ngClass]="{ active: step! === progresItem.index }"
                >
                    {{ progresItem.index }}
                </span>
                <p class="text-uppercase">{{ progresItem.name | translate }}</p>
            </div>
        </ng-template>
    </div>
</div>
